<template>
  <Layout>
    <PageHeader :title="PageHeaderT" :items="PageHeaderItems" />
    <div class="block_content position-relative">
      <div class="modal-content">
        <div class="modal-header bg-light p-3">
          <h5 class="modal-title">{{ getLangValue("base.user_info") }}</h5>
          <div class="d-flex align-items-center">
            <div class="text-primary me-3 cursor" @click="toggleStatus()">
              <i class="fs-18 ri-pencil-fill"></i>
            </div>
            <div class="text-primary cursor" @click="handleClose()">
              <i class="fs-24 ri-close-line"></i>
            </div>
          </div>
        </div>
        <form action="#" id="addform">
          <div class="modal-body">
            <div class="row gy-3">
              <!-- 名称 -->
              <!-- <div>
                <label for="weight-field" class="form-label">
                  <span class="text-danger">*</span>
                  <span>{{ getLangValue("attribute.name") }}</span>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.name"
                  :class="{
                    'is-invalid': submitted && v$.form.name.$error,
                  }"
                  required
                  :disabled="isAbled"
                />
                <div
                  v-for="(item, index) in v$.form.name.$errors"
                  :key="index"
                  class="invalid-feedback"
                >
                  <span v-if="item.$message">{{ item.$message }}</span>
                </div>
              </div> -->
              <!-- 用户名 -->
              <div>
                <label for="weight-field" class="form-label">
                  <span class="text-danger">*</span>
                  <span>{{ getLangValue("base.user_center_name") }}</span>
                </label>
                <input type="text" class="form-control" v-model="form.username" 
                 required disabled />
                <!-- <div v-for="(item, index) in v$.form.username.$errors" :key="index" class="invalid-feedback">
                  <span v-if="item.$message">{{ item.$message }}</span>
                </div> -->
              </div>
              <!-- 密码 -->
              <div>
                <label for="weight-field" class="form-label">
                  <span class="text-danger">*</span>
                  <span>{{ getLangValue("attribute.password") }}</span>
                </label>
                <div class="position-relative auth-pass-inputgroup">
                  <input type="password" autocomplete="new-passWord" class="form-control" style="padding-right: 3rem"
                    v-model="form.password"  required disabled />
                  <!-- <div v-for="(item, index) in v$.form.password.$errors" :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                  </div> -->
                  <div class="mt-2 text-end">
                    <a href="javascript:void(0);" class="link-primary text-decoration-underline"
                      @click="() => (showEditPassWord = true)">{{ getLangValue("base.change_password") }}</a>
                  </div>
                </div>
              </div>
              <!-- 角色 -->
              <div>
                <label for="weight-field" class="form-label">
                  <span class="text-danger">*</span>
                  <span>{{ getLangValue("attribute.role") }}</span>
                </label>
                <input type="text" class="form-control" v-model="form.roleName" required disabled />
                <!-- <div v-for="(item, index) in v$.form.role.$errors" :key="index" class="invalid-feedback">
                  <span v-if="item.$message">{{ item.$message }}</span>
                </div> -->
              </div>
              <!-- 组织 -->
              <!-- <div>
                <label class="form-label">{{
                  getLangValue("attribute.organization")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="form.department"
                  :disabled="isAbled"
                />
              </div> -->
              <!-- 描述 -->
              <div>
                <label for="weight-field" class="form-label">{{
                  getLangValue("attribute.description")
                }}</label>
                <b-form-textarea id="textarea" v-model="form.description" rows="3" max-rows="6"
                  :disabled="isAbled"></b-form-textarea>
              </div>
              <!-- 手机 -->
              <div>
                <label class="form-label">{{ getLangValue("attribute.phone") }}</label>
                <input type="text" class="form-control" v-model="form.mobile_phone_number" :disabled="isAbled" />
              </div>
              <!-- 邮箱 -->
              <div>
                <label class="form-label">{{ getLangValue("attribute.email") }}</label>
                <input type="text" class="form-control" v-model="form.contact_email" :disabled="isAbled" />
              </div>
            </div>
          </div>
          <div class="modal-footer" v-if="formType == 'edit'">
            <div class="hstack gap-2 justify-content-end">
              <button type="button" class="btn btn-light me-4" @click="handleClose()" :disabled="formValidataAlert">
                {{ getLangValue("base.cancel") }}
              </button>
              <button type="button" class="btn btn-success" id="add-btn" @click="handleSubmit()"
                :disabled="formValidataAlert">
                {{ getLangValue("base.done") }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <ChangePassWord v-if="showEditPassWord" v-model:showEditPassWord="showEditPassWord"></ChangePassWord>
    <message-alert :alertInfo="alertInfo" v-if="formValidataAlert" :showCloseBtn="true"
      v-model:formValidataAlert="formValidataAlert"></message-alert>
  </Layout>
</template>

<script>
import { getUser_center_v3, postUser_center_v3 } from "@/service/apiList/userCenter";
// import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";
// import i18n from "@/i18n";
// import _ from "loadsh";
import ChangePassWord from "./changePassWord.vue";
import { getLangValue } from "@/utils/common"; //获取后端语言
export default {
  setup() {
    return { v$: useVuelidate() };
  },
  validations: {
    form: {
      // name: {
      //   required: helpers.withMessage(
      //     i18n.global.t("user.hint_name"),
      //     required
      //   ),
      // },
      // username: {
      //   required: helpers.withMessage(
      //     i18n.global.t("user.hint_user_name"),
      //     required
      //   ),
      // },
      // password: {
      //   required: helpers.withMessage(
      //     i18n.global.t("user.hint_password"),
      //     required
      //   ),
      // },
      // role: {
      //   required: helpers.withMessage(
      //     i18n.global.t("user.hint_role"),
      //     required
      //   ),
      // },
    },
  },
  data() {
    return {
      PageHeaderT: this.getLangValue("base.user_info"),
      PageHeaderItems: [],
      form: {
        name: "",
        description: "",
        disabled: false,
        roleName: '',
      },
      submitted: false,
      formValidataAlert: false,
      alertInfo: {
        variant: "success",
        content: "",
        icon: "ri-error-warning-line",
      },
      formType: "view",
      showEditPassWord: false,
    };
  },
  computed: {
    isAbled() {
      if (this.formType == "edit") {
        return false;
      } else {
        return true;
      }
    },
  },
  mounted() {
    this.initUserInfo();
  },
  methods: {
    getLangValue,
    initUserInfo() {
      getUser_center_v3().then((res) => {
        console.log(res);
        if (res && res.payload) {
          this.form = res.payload;
          this.form.roleName = this.form.role? this.form.role.name: ''
        }
      });
    },
    handleSubmit() {
      this.submitted = true;
      this.v$.$touch();

      if (this.v$.$invalid) {
        return;
      } else {
        // let params = _.cloneDeep(this.form);
        // params["confirm_password"] = this.form.password;
        // params["disabled"] = !this.form.disabled;
        // if (this.form.role) {
        //   params["role"] = [this.form.role];
        // } else {
        //   params["role"] = [];
        // }

        // _.forEach(this.grantAll, function (value, key) {
        //   if (value.show) {
        //     params[key] = value.value;
        //   }
        // });
        let params= {
          mobile_phone_number: this.form.mobile_phone_number,
          contact_email: this.form.contact_email,
          description: this.form.description,
        }
        let check = true
        // console.log(params);
        if (check) {
          postUser_center_v3(params)
            .then((res) => {
              if (res) {
                let info = {
                  variant: "success",
                  content: this.getLangValue("base.edit_success"),
                  icon: "ri-alert-line",
                };
                this.openAlert(info, "close");
                // this.$emit("initRoleList");
              }
            })
            .catch((err) => {
              let info = {
                variant: "danger",
                content: err.message,
                icon: "ri-error-warning-line",
              };
              this.openAlert(info, "close");
            });
        }
      }
    },
    handleClose() {
      this.$router.back();
    },
    toggleStatus() {
      if (this.formType == "view") {
        this.formType = "edit";
      } else {
        this.formType = "view";
      }
    },
    /* 消息提示框 */
    openAlert(info, close) {
      if (info) {
        this.alertInfo = info;
      }
      this.formValidataAlert = true;
      if (close) {
        setTimeout(() => {
          this.formValidataAlert = false;
          this.handleClose();
        }, 2000);
      }
    },
  },
  components: {
    ChangePassWord,
  },
};
</script>

<style scoped lang='scss'>
.modal-content {
  width: 50%;
  max-height: 100%;
  overflow: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
